import { useTranslations } from 'next-intl'

import { Article, SocialMediaType } from '@/services/coin/social'

import BaseCard from './BaseCard'
import YoutubeVideo from './YoutubeVideo'

type Props = {
  video: Article
}

export default function VideoCard({ video }: Props) {
  const t = useTranslations('newsCommunity')

  if (!video) return null

  return (
    <BaseCard
      title={video.title || ''}
      description={video.description}
      source={t('youtube')}
      pubDate={video.pubDate}
      type={SocialMediaType.Video}
      showDescription={false}
      link={video.link}
    >
      <YoutubeVideo
        videoSrc={video.link}
        thumbnail={video.thumbnail}
        restStyle={{ height: '80px', width: '100%' }}
      />
    </BaseCard>
  )
}
